export default __webpack_public_path__ + "static/media/PM-Form-Integrations-01-1.bc56685c.webp";